export default __webpack_public_path__ + "static/media/d2497f501d0c62cb10b48ea8d34220a9449ae9193317d0396629e2ea6afeea1b.06f222e2.svg";